import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, ListIDPs, ListScimGroups } from '../../../functions/ZPA';
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Multiselect from 'multiselect-react-dropdown';
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { objectToOperationString } from '../../../functions/misc';
import InputGroup from 'react-bootstrap/InputGroup';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'
import { groups_object } from '../../tabs';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
library.add(faAngleDown)

function DownloadScimGroups({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab }) {
    const [isLoading, setLoading] = useState(0);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [tenant, setTenant] = useState("Rheintec");
    const [idps, setIdps] = useState(groups_object)
    const [outputConsole, setOutputConsole] = useState("");
    const [selected, setSelected] = useState(``);
    const [accessToken, setAccessToken] = useState("");
    const textareaRef = useRef();
    const [description, setDescription] = useState("")
    const [descriptionTag, setDescriptionTag] = useState("")

    const multiselectRef = useRef();

    const exportToExcel = (data) => {
        // Convert data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate Excel file and download it
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        // Convert Excel file to Blob for download
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        // Use FileSaver to download the file
        saveAs(blob, `${tenant}_${selected}.xlsx`);
    };


    const handleSelectIdp = (selectedList) => {
        if (selectedList.length > 0) {
            setSelected(selectedList[0].id);
        } else {
            setSelected('');
        }
    };

    function copyList(list) {
        const text = ListToText(list);
        navigator.clipboard.writeText(text);
    }

    function ListToText(list) {
        let text = "";
        for (let i = 0; i < list.length; i++) {
            text += i === 0 ? list[i] : "\n" + list[i];
        }
        return text;
    }

    async function getIdps() {
        setSelected(``)
        let new_idps = { ...idps };
        Object.keys(idps).forEach(async (key) => {
            const access_token = await authenticate(key);
            if (access_token) {
                const idps_response = await ListIDPs(key, access_token)
                if (idps_response.status === 200) {
                    const idps_json = await idps_response.json()
                    const idp_list = idps_json.idps;
                    new_idps[key] = idp_list || [];
                    console.log("NEW")
                    console.log(new_idps)
                    setIdps({ ...new_idps });
                }
                else {
                    appendConsole(`\nError: ${idps_response.message}`);
                    appendConsoleSeperatorMain();
                }
            }

        });


    }

    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + "\t" + dashes);
    }

    async function authenticate(tenant) {
        try {
            const response = await Auth(tenant);
            const auth_json = await response.json();
            if (response.status === 200) {
                const access_token = auth_json.access_token;
                return access_token;
            }
            else {
                appendConsole(`\nAuth Error: ${tenant} - ${auth_json.message}`);
                appendConsoleSeperatorMain();
            }
        }
        catch (error) {
            console.log(error)
            appendConsole(`\nAuth Error: ${tenant} - ${error.message}`);
            appendConsoleSeperatorMain();
        }
    }


    async function handleSubmit(event) {

        //Prerequisites
        setOutputConsole(``);
        setLoading(0);
        event.preventDefault();

        //Authenticate
        setLoadingMessage("Initiating Session...");
        const access_token = await authenticate(tenant);
        setAccessToken(access_token);
        setOutputConsole(`Authenticated`);
        appendConsoleSeperatorMain();

        setLoading(30)
        try {
            let response = await ListScimGroups(tenant, selected, access_token)
            if (response.status === 200) {
                const response_data = await response.json();
                const scim_groups = response_data.scim_groups
                const filtered_scim_groups = scim_groups.map((group) => ({ "name": group.name, "id": group.id }))
                console.log(filtered_scim_groups)
                exportToExcel(filtered_scim_groups)
                scim_groups.forEach((group, index) => {
                    appendConsole(`\nID: ${group.id}\tName: ${group.name}`)
                });
            } else if (response.status === 429) {
                appendConsole("Rate limit error")
            }
            else {
                appendConsole("\nServer error")
                appendConsole("\n" + await response.text())
            }

        }
        catch (error) {
            appendConsole("\nInternal Error")
            appendConsole("\n" + error)
            console.error(error);
            terminateSession(access_token)
        }
        setLoading(100)
        terminateSession(access_token)
    }


    // Function to scroll the textarea to the bottom
    const scrollToBottom = () => {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    };

    const scrollToTop = () => {
        textareaRef.current.scrollTop = 0;
    };

    useEffect(() => {
        if (selectedTab === "downloadScimGroups" && verified) {
            console.log("IN")
            handleSubmit(new Event("LOL"))
        }
        setVerified(false);
    }, [verified])

    useEffect(() => {
        setSelected(``)
    }, [tenant])

    useEffect(() => {
        if (selected == "") {
            multiselectRef.current.resetSelectedValues();

        }
    }, [selected])



    useEffect(() => {
        scrollToBottom();
    }, [outputConsole])

    useEffect(() => {
        scrollToTop();
    }, [isLoading])


    useEffect(() => {
        console.log("IDPS")
        console.log(idps)

    }, [idps])




    useEffect(() => {
        if (idps[tenant].length == []) {
            getIdps();
        }
        const JWT = Cookies.get('CF_Authorization');
        const decodedJWT = jwtDecode(JWT)
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const date = `${day}-${month}-${year}`;
        setDescriptionTag(`${date}/${decodedJWT.email}`)
    }, [])



    async function terminateSession(access_token) {
        //Signout
        setLoadingMessage("Terminating Session...");
        await SignOut(access_token);
        setLoading(0);
    }
    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                Select tenant
                            </Form.Label>
                            <Form.Select aria-label="Default select example" value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    Object.keys(groups).map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="idps" className='mt-4'>
                            <Form.Label>
                                {idps[tenant].length === 0 ?
                                    <>
                                        <Spinner
                                            variant='light'
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                        />
                                        &nbsp;&nbsp;
                                    </> : <></>}
                                IDPs
                            </Form.Label>
                            <Multiselect
                                options={idps[tenant].map(idp => ({ name: idp.name, id: idp.id }))}
                                displayValue="name"
                                ref={multiselectRef}
                                selectionLimit={1}
                                placeholder="Select Group"
                                onSelect={handleSelectIdp}
                                showCheckbox="true"
                                showArrow="true"
                                customArrow={<FontAwesomeIcon icon="fa-solid fa-angle-down" style={{ color: "#c6cbce", }} size='sm' />}

                            />
                        </FormGroup>

                        <Button className='mt-4 text-light' type='submit' disabled={isLoading || selected.length < 1} variant="success" >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : `Download SCIM Groups`}
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-5 '>
                <Col>
                    <ProgressBar className='mb-2' now={isLoading} />
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle text-rheintec-blue output-terminal' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>

        </Container >

    );

}

export default DownloadScimGroups;